// extracted by mini-css-extract-plugin
export default {"ant-table-thead":"forgotPasswordForm_ant-table-thead__xV-Qy","form-items":"forgotPasswordForm_form-items__5SSzY","form-input-block":"forgotPasswordForm_form-input-block__SsJxF"};